import { render, staticRenderFns } from "./LoadingRectangles.vue?vue&type=template&id=77e20e9c&scoped=true&"
var script = {}
import style0 from "./LoadingRectangles.vue?vue&type=style&index=0&id=77e20e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e20e9c",
  null
  
)

export default component.exports